import React, { useState } from 'react'
import IndSectionTabs from '../../components/IndSectionTabs'

const tabData = [
   {
      id: '01ete',
      title: '01. Custom Social Networking Application Development',
      intitle: 'Custom Social Networking Application Development',
      icon: '/assets/svg/industries/social/s1.svg',
      content:
         'We create tailor-made social networking apps with friend requests, profile management, activity feeds, and real-time notifications. Our solutions ensure seamless user interactions and foster strong online communities. We develop platforms with intuitive UI/UX, customizable profiles, and advanced privacy settings. Our solutions comprise content-sharing features, event creation, and group management. With AI-driven content suggestions, real-time messaging, and multimedia support, we empower businesses to create scalable and interactive social ecosystems.',
   },
   {
      id: '02ete',
      title: '02. Social Network Data Analysis & Insights Tools',
      intitle: 'Social Network Data Analysis & Insights Tools',
      icon: '/assets/svg/industries/social/s2.svg',
      content:
         'Our social network analysis solutions provide rich insights into user behavior, interactions, and trends, allowing businesses to improve their strategies and increase engagement. We create platforms with real-time analytics dashboards, sentiment analysis, and trend monitoring. Our solutions comprise data visualization, audience segmentation, and engagement heatmaps. With AI-powered predictive insights and in-depth reporting, we enable businesses to maximize marketing campaigns, detect influencers, and enhance content strategies.',
   },
   {
      id: '03ete',
      title: '03. Real-Time Messaging App Development',
      intitle: 'Real-Time Messaging App Development',
      icon: '/assets/svg/industries/social/s3.svg',
      content:
         'We construct secure and feature-rich messaging apps with instant messaging, multimedia sharing, and voice/video calling to provide real-time and encrypted communication. Our offerings encompass end-to-end encryption, self-destructing messages, and multimedia support. We develop platforms with real-time typing indicators, message delivery tracking, and customizable chat themes. With AI-powered spam filtering, offline messaging, and seamless cross-platform compatibility, we enhance communication reliability and security.',
   },
   {
      id: '04ete',
      title: '04. Video-Centric Social Applications & Streaming Platforms',
      intitle: 'Video-Centric Social Applications & Streaming Platforms',
      icon: '/assets/svg/industries/social/s4.svg',
      content:
         'Our apps based on video involve live broadcast, video conversation, and interactive content, bringing dynamic and captivating user experiences. We create platforms with HD streaming of video, low-latency broadcasting, and interactive functionalities like live comments and reactions. Our offerings involve VOD libraries, AI-driven recommendations, and monetization capabilities. With adaptive stream, real-time audience analytics, and seamless integrations with third parties, we enable businesses to build compelling video-focused social sites.',
   },
   {
      id: '05ete',
      title: '05. Mobile Dating Applications with AI-Powered Matchmaking',
      intitle: 'Mobile Dating Applications with AI-Powered Matchmaking',
      icon: '/assets/svg/industries/social/s5.svg',
      content:
         'Our custom dating apps feature AI-driven matchmaking, real-time chat, and profile swiping, delivering personalized and secure dating experiences. We develop platforms with intelligent matching algorithms, geolocation-based suggestions, and user preference filtering. Our features encompass real-time chat, photo verification, and anti-fraud protection. Through in-app purchases, push notifications, and easy social media connectivity, we assist companies in constructing secure, user-friendly, and scalable dating platforms.',
   },
]; 

function IndSectionTwo() {
   return (
      <section className="section_secondary_bg">
         <div className="container">
            <h2 className="text-center tech_title section_heading_title mb-2">
               Top-Tier Social & Dating Software Development Solutions
            </h2>
            <p className="section_desc end-to-end-section mb-xl-0 mb-4">
               Discover our high-end social and dating application development solutions aimed at increasing user interaction, connectivity, and security. We are expert developers of feature-intensive platforms with advanced features, providing top-notch user experiences.
            </p>
            <IndSectionTabs tabData={tabData} />
         </div>
      </section>
   )
}

export default IndSectionTwo
